import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import XLSX from 'xlsx';
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import * as ReactGA from "react-ga";

function excelDateToTimestamp(date) {
    return (new Date(Math.round((date - 25569)*86400*1000)).getTime() / 1000);
}

export class ImportJumps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            fileUploaded: false,
            jumps: []
        };
    }

    handleClose = () => {
        this.setState({
            show: false
        })
    }

    handleShow = () => {
        this.setState({
            show: true
        })
    }


    setFileUploaded = (fileUploaded) => {
        this.setState({
            fileUploaded: fileUploaded
        });
    }

    setJumps = (jumps) => {
        this.setState({
            jumps: jumps
        });
    }

    handleFile = (file) => {
        const reader = new FileReader();
        const readAsBinaryString = !!reader.readAsBinaryString;

        reader.onload = e => {
            const binaryString = e.target.result;
            const workBook = XLSX.read(binaryString, {
                type: readAsBinaryString ? "binary" : "array",
                raw: false,
                // dateNF: "dd.MM.yyyy"
            });
            const sheetNames = workBook.SheetNames[0];
            const workSheet = workBook.Sheets[sheetNames];
            const data = XLSX.utils.sheet_to_json(workSheet, { header: 1 });

            let parsedJumps = [];

            data.map((jump, index) => {
                if(index !== 0) {
                    let jumpValid =
                        (jump[0] && jump[0] > 0)
                        && (jump[2])
                        && (jump[3]);

                    if(jumpValid) {
                        let newJump = {
                            "jumpNumber": jump[0],
                            "title": jump[1],
                            "date": excelDateToTimestamp(jump[2]),
                            "dropzone": jump[3],
                            "canopy": jump[4],
                            "wingsuit": jump[5],
                            "freeFallTime": jump[6],
                            "aircraft": jump[7],
                            "exitAltitude": jump[8],
                            "deployAltitude": jump[9],
                            "distanceFromTarget": jump[10],
                            "comment": jump[11]
                        }
                        parsedJumps = parsedJumps.concat(newJump);
                    }
                }
            });

            this.setJumps(parsedJumps);
        };
        if (readAsBinaryString) {
            reader.readAsBinaryString(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    };

    handleChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) {
            this.handleFile(files[0]);
        }
    }

    supportedExtensions = ["xlsx", "xls", "csv"].map(ext => "." + ext).join(",");

    render() {
        return (
            <>
                <Button className="mr-2" variant="primary" onClick={this.handleShow}>
                    Import from spreadsheet
                </Button>

                <Modal show={this.state.show}
                       onHide={this.handleClose}
                       size="lg"
                       aria-labelledby="contained-modal-title-vcenter"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Import from spreadsheet
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Form>
                                <p>Fill the table, using provided <a href="Logbook.xlsx">XLSX template</a>.</p>
                                <p>We would ignore all rows, which not contain the whole set of required fields.</p>
                                <p className="prompt-color">Please do not modify table structure. Otherwise, we cannot properly process data.</p>

                                <Form.File id="csv-upload" custom>
                                    <Form.File.Input accept={this.supportedExtensions} onChange={(event) => {
                                        this.handleChange(event);
                                        this.setFileUploaded(true);
                                    }}/>
                                    <Form.File.Label data-browse="Browse">
                                        Choose file
                                    </Form.File.Label>
                                </Form.File>
                                <p className="mt-3">
                                    {
                                        this.state.fileUploaded
                                            ? "Jumps to upload: " + this.state.jumps.length
                                            : null
                                    }
                                </p>
                            </Form>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary"  onClick={(e) => {
                            this.state.jumps.forEach(jump => this.props.addForm(jump));
                            this.setJumps([]);
                            this.handleClose();
                            ReactGA.event({
                                category: 'User',
                                action: 'Added new jumps to upload from spreadsheet'
                            });
                        }}>Upload</Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}